import React, { useState } from "react";
import Select from "react-select";
import Button from "@mui/joy/Button";
import Add from "@mui/icons-material/Add";
import { toast } from "react-hot-toast";
import axios from "axios";
import API_BASE_URL from "../../config/config.js";

const CreatePhase = ({ eventos, deportes }) => {
  const [selectedEvent, setSelectedEvent] = useState(null); // Evento seleccionado
  const [selectedSport, setSelectedSport] = useState(null); // Deporte seleccionado
  const [phaseType, setPhaseType] = useState(1); // 1 = Primera Fase, 2 = Fase Final
  const [tagDescription, setTagDescription] = useState("Todos contra todos"); // "Todos contra todos" o "Fase de Grupos"

  const handleAddPhase = async () => {
    if (!selectedEvent || !selectedSport) {
      toast.error("Debe seleccionar un evento y un deporte.");
      return;
    }

    // Validación adicional para "Primera Fase"
    if (phaseType === 1 && !tagDescription) {
      toast.error("Debe seleccionar una descripción de la fase.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/phase`, {
        idevent: selectedEvent.value,
        idsport: selectedSport.value,
        idtypephase: phaseType,
        tag: phaseType === 2 ? "Fase Final" : tagDescription,
      });

      if (response.status === 201) {
        toast.success("Fase creada con éxito!");
      }
    } catch (error) {
      toast.error("Error al crear la fase.");
      console.error("Error:", error);
    }
  };

  const handlePhaseTypeChange = (type) => {
    setPhaseType(type);
    if (type === 2) {
      setTagDescription("Fase Final"); // Cambiar automáticamente la descripción del tag
    } else {
      setTagDescription("Todos contra todos"); // Resetear a un valor por defecto
    }
  };

  return (
    <div className="bg-white p-5 rounded-2xl dark:bg-gray-600 dark:text-gray-300 flex-1">
      <div>
        <h5 className="mb-2 text-2xl font-medium font-bold text-gray-700 dark:text-neutral-50">
          Crear Fase
        </h5>
      </div>

      {/* Select para el evento */}
      <div className="mb-4">
        <Select
          options={eventos.map((evento) => ({
            value: evento.idchampionship,
            label: evento.name,
          }))}
          value={selectedEvent}
          onChange={(option) => setSelectedEvent(option)}
          placeholder="Selecciona un evento"
          isSearchable
          className="w-full"
        />
      </div>

      {/* Select para el deporte */}
      <div className="mb-4">
        <Select
          options={deportes.map((deporte) => ({
            value: deporte.idsport,
            label: deporte.name,
          }))}
          value={selectedSport}
          onChange={(option) => setSelectedSport(option)}
          placeholder="Selecciona un deporte"
          isSearchable
          className="w-full"
        />
      </div>

      {/* RadioButtons para el tipo de fase */}
      <div className="mb-4">
        <label className="block text-gray-700 dark:text-white font-medium mb-2">
          Tipo de Fase
        </label>
        <div className="flex space-x-4">
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="phaseType"
              value="1"
              checked={phaseType === 1}
              onChange={() => handlePhaseTypeChange(1)}
            />
            <span>Primera Fase</span>
          </label>
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="phaseType"
              value="2"
              checked={phaseType === 2}
              onChange={() => handlePhaseTypeChange(2)}
            />
            <span>Fase Final</span>
          </label>
        </div>
      </div>

      {/* RadioButtons para el tag description */}
      <div className="mb-4">
        <label className="block text-gray-700 dark:text-white font-medium mb-2">
          Descripción de la Fase
        </label>
        <div className="flex space-x-4">
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="tagDescription"
              value="Todos contra todos"
              checked={tagDescription === "Todos contra todos"}
              onChange={() => setTagDescription("Todos contra todos")}
              disabled={phaseType === 2} // Desactivar si es Fase Final
            />
            <span className={phaseType === 2 ? "text-gray-400" : ""}>
              Todos contra todos
            </span>
          </label>
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="tagDescription"
              value="Fase de Grupos"
              checked={tagDescription === "Fase de Grupos"}
              onChange={() => setTagDescription("Fase de Grupos")}
              disabled={phaseType === 2} // Desactivar si es Fase Final
            />
            <span className={phaseType === 2 ? "text-gray-400" : ""}>
              Fase de Grupos
            </span>
          </label>
        </div>
      </div>

      {/* Botón para añadir fase */}
      <div>
        <Button startDecorator={<Add />} onClick={handleAddPhase}>
          Añadir Fase
        </Button>
      </div>
    </div>
  );
};

export default CreatePhase;
